// 테스트 관련 코드, 추후 삭제 예정
/**
 * 약관확인 — 테스트 임시 페이지
 *
 * 상단 콤보(약관 유형: ZEU_TERM_TYPE)에서 유형을 고르면,
 * 해당 유형의 약관(BE는 현재 ACTIVE_YN=Y 1건 반환)을 하단에 HTML로 렌더한다.
 */
import { useEffect, useState } from 'react';
import { Select } from '@indipia/ui-core';
import { fetchTermsTypes, fetchTerms, type TermsTypeCode, type TermsContent } from './testApi';

export function TestTermsPage() {
  const [types, setTypes] = useState<TermsTypeCode[]>([]);
  const [selected, setSelected] = useState('');
  const [terms, setTerms] = useState<TermsContent | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 유형 목록 로드
  useEffect(() => {
    fetchTermsTypes()
      .then(setTypes)
      .catch(() => setError('약관 유형을 불러오지 못했습니다.'));
  }, []);

  // 유형 선택 시 약관 조회
  useEffect(() => {
    if (!selected) { setTerms(null); setError(null); return; }
    setLoading(true);
    setError(null);
    setTerms(null);
    fetchTerms(selected)
      .then((t) => {
        if (t) setTerms(t);
        else setError('해당 유형의 약관이 없습니다.');
      })
      .catch(() => setError('해당 유형의 약관이 없습니다.'))
      .finally(() => setLoading(false));
  }, [selected]);

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-6">
      {/* 배너 */}
      <div className="rounded-xl border border-warning bg-surface-subtle px-4 py-3">
        <p className="text-xs font-semibold text-warning">테스트 임시 페이지 — 프로덕션 미노출</p>
        <p className="mt-0.5 text-xs text-text-secondary">약관확인 · 유형 선택 시 최신 약관 표시</p>
      </div>

      {/* 유형 콤보 */}
      <div className="flex items-center gap-3">
        <label className="text-sm text-text-secondary">약관 유형</label>
        <Select
          className="min-w-56"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        >
          <option value="">유형을 선택하세요</option>
          {types.map((t) => (
            <option key={t.codeValue} value={t.codeValue}>{t.codeName}</option>
          ))}
        </Select>
      </div>

      {/* 본문 */}
      <div className="min-h-[300px] rounded-xl border border-border-default bg-white p-6">
        {loading && <p className="text-sm text-text-secondary">불러오는 중…</p>}
        {!loading && error && <p className="text-sm text-error">{error}</p>}
        {!loading && !error && !terms && (
          <p className="text-sm text-text-secondary">상단에서 약관 유형을 선택하세요.</p>
        )}
        {!loading && !error && terms && (
          <article>
            <h1 className="mb-1 text-lg font-semibold text-text-primary">{terms.termsTitle}</h1>
            <div
              className="mt-4 text-sm leading-relaxed text-text-primary [&_h1]:mb-2 [&_h1]:text-base [&_h1]:font-semibold [&_h2]:mb-2 [&_h2]:mt-4 [&_h2]:font-semibold [&_li]:ml-4 [&_li]:list-disc [&_p]:mb-2 [&_ul]:mb-2"
              dangerouslySetInnerHTML={{ __html: terms.termsContent }}
            />
          </article>
        )}
      </div>
    </div>
  );
}
